import { render, staticRenderFns } from "./ClientMaster.vue?vue&type=template&id=458c862f&scoped=true&"
import script from "./ClientMaster.vue?vue&type=script&lang=js&"
export * from "./ClientMaster.vue?vue&type=script&lang=js&"
import style0 from "./ClientMaster.vue?vue&type=style&index=0&id=458c862f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458c862f",
  null
  
)

export default component.exports